// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar_container {
	height: calc(100vh - 100px);
	background-color: #0E0A40;
	padding-top: 30px;
	padding-right: 15px;
	z-index: 3000;
	min-width: 200px;
}

.hide_sidebar {
	width: 90px;
	height: calc(100vh - 100px);
	background-color: #0E0A40;
	padding-top: 30px;

}

@media (max-width: 1000px) {
	.hide_sidebar {
		display: none;
	}
}

.sidebar_tab {
	font-family: Montserrat, sans-serif;
	width: 100%;
	height: 50px;
	cursor: pointer;
	transition: 0.2s;
	padding-left: 10px;
	padding-right: 5px;
	font-size: 12px;
	font-weight: 600;
	color: #767493;
}

.sidebar_tab:hover {
	background: rgb(255, 255, 255);
	background: linear-gradient(95deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.17) 13%, rgba(255, 255, 255, 0.14) 28%, rgba(255, 255, 255, 0.1) 44%, rgba(255, 255, 255, 0.06) 67%, rgba(255, 255, 255, 0.02) 100%);
	border-left: 3px solid #f35252;
	color: #ffffff;
	font-size: 14px;
	font-weight: 700;
}

.sidebar_tab:hover #dashboard_icon {
	filter: brightness(3) contrast(3) saturate(1.4);
}

.selected_tab {
	background: rgb(255, 255, 255);
	background: linear-gradient(95deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.17) 13%, rgba(255, 255, 255, 0.14) 28%, rgba(255, 255, 255, 0.1) 44%, rgba(255, 255, 255, 0.06) 67%, rgba(255, 255, 255, 0.02) 100%);
	border-left: 3px solid #f35252;
	color: white;
	font-size: 14px;
}

.selected_tab #dashboard_icon {
	filter: brightness(3) contrast(3) saturate(1.4);
}

.sidebar_text {
	padding-left: 10px;
	font-weight: 100;
}

.sidebar_dropdown-container {
	display: flex;
	flex-direction: column;
	transition: .5s;
}

.sidebar_dropdown-container .sidebar_tab {
	padding-left: 18px;
}

.sidebar_caret-up {
	position: absolute;
	top: 0;
	right: 4px;
	bottom: 0;
	margin: auto;
	transition: .4s;
	transform: rotateZ(0);
}

.sidebar_caret-down {
	position: absolute;
	top: 0;
	right: 4px;
	bottom: 0;
	margin: auto;
	transition: .4s;
	transform: rotateZ(180deg);
}


@media (max-width: 1300px) {
	.sidebar_container {
		position: absolute;
		z-index: 999;
	}
}`, "",{"version":3,"sources":["webpack://./src/Components/Sidebar/Sidebar.css"],"names":[],"mappings":"AAAA;CACC,2BAA2B;CAC3B,yBAAyB;CACzB,iBAAiB;CACjB,mBAAmB;CACnB,aAAa;CACb,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,2BAA2B;CAC3B,yBAAyB;CACzB,iBAAiB;;AAElB;;AAEA;CACC;EACC,aAAa;CACd;AACD;;AAEA;CACC,mCAAmC;CACnC,WAAW;CACX,YAAY;CACZ,eAAe;CACf,gBAAgB;CAChB,kBAAkB;CAClB,kBAAkB;CAClB,eAAe;CACf,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,8BAA8B;CAC9B,0NAA0N;CAC1N,8BAA8B;CAC9B,cAAc;CACd,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,+CAA+C;AAChD;;AAEA;CACC,8BAA8B;CAC9B,0NAA0N;CAC1N,8BAA8B;CAC9B,YAAY;CACZ,eAAe;AAChB;;AAEA;CACC,+CAA+C;AAChD;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,eAAe;AAChB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,UAAU;CACV,SAAS;CACT,YAAY;CACZ,eAAe;CACf,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,UAAU;CACV,SAAS;CACT,YAAY;CACZ,eAAe;CACf,0BAA0B;AAC3B;;;AAGA;CACC;EACC,kBAAkB;EAClB,YAAY;CACb;AACD","sourcesContent":[".sidebar_container {\n\theight: calc(100vh - 100px);\n\tbackground-color: #0E0A40;\n\tpadding-top: 30px;\n\tpadding-right: 15px;\n\tz-index: 3000;\n\tmin-width: 200px;\n}\n\n.hide_sidebar {\n\twidth: 90px;\n\theight: calc(100vh - 100px);\n\tbackground-color: #0E0A40;\n\tpadding-top: 30px;\n\n}\n\n@media (max-width: 1000px) {\n\t.hide_sidebar {\n\t\tdisplay: none;\n\t}\n}\n\n.sidebar_tab {\n\tfont-family: Montserrat, sans-serif;\n\twidth: 100%;\n\theight: 50px;\n\tcursor: pointer;\n\ttransition: 0.2s;\n\tpadding-left: 10px;\n\tpadding-right: 5px;\n\tfont-size: 12px;\n\tfont-weight: 600;\n\tcolor: #767493;\n}\n\n.sidebar_tab:hover {\n\tbackground: rgb(255, 255, 255);\n\tbackground: linear-gradient(95deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.17) 13%, rgba(255, 255, 255, 0.14) 28%, rgba(255, 255, 255, 0.1) 44%, rgba(255, 255, 255, 0.06) 67%, rgba(255, 255, 255, 0.02) 100%);\n\tborder-left: 3px solid #f35252;\n\tcolor: #ffffff;\n\tfont-size: 14px;\n\tfont-weight: 700;\n}\n\n.sidebar_tab:hover #dashboard_icon {\n\tfilter: brightness(3) contrast(3) saturate(1.4);\n}\n\n.selected_tab {\n\tbackground: rgb(255, 255, 255);\n\tbackground: linear-gradient(95deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.17) 13%, rgba(255, 255, 255, 0.14) 28%, rgba(255, 255, 255, 0.1) 44%, rgba(255, 255, 255, 0.06) 67%, rgba(255, 255, 255, 0.02) 100%);\n\tborder-left: 3px solid #f35252;\n\tcolor: white;\n\tfont-size: 14px;\n}\n\n.selected_tab #dashboard_icon {\n\tfilter: brightness(3) contrast(3) saturate(1.4);\n}\n\n.sidebar_text {\n\tpadding-left: 10px;\n\tfont-weight: 100;\n}\n\n.sidebar_dropdown-container {\n\tdisplay: flex;\n\tflex-direction: column;\n\ttransition: .5s;\n}\n\n.sidebar_dropdown-container .sidebar_tab {\n\tpadding-left: 18px;\n}\n\n.sidebar_caret-up {\n\tposition: absolute;\n\ttop: 0;\n\tright: 4px;\n\tbottom: 0;\n\tmargin: auto;\n\ttransition: .4s;\n\ttransform: rotateZ(0);\n}\n\n.sidebar_caret-down {\n\tposition: absolute;\n\ttop: 0;\n\tright: 4px;\n\tbottom: 0;\n\tmargin: auto;\n\ttransition: .4s;\n\ttransform: rotateZ(180deg);\n}\n\n\n@media (max-width: 1300px) {\n\t.sidebar_container {\n\t\tposition: absolute;\n\t\tz-index: 999;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
